import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const ToastContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #8B5CF6 0%, #A78BFA 100%);
  color: white;
  padding: 14px 28px;
  border-radius: 12px;
  z-index: 1000;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  opacity: ${props => props.show ? 1 : 0};
  visibility: ${props => props.show ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
  max-width: 80%;
  text-align: center;
  box-shadow: 0 8px 16px rgba(139, 92, 246, 0.25);
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &::before {
    content: '';
    width: 4px;
    height: 4px;
    background: white;
    border-radius: 50%;
    margin-right: 4px;
    opacity: 0.8;
  }

  &::after {
    content: '';
    width: 4px;
    height: 4px;
    background: white;
    border-radius: 50%;
    margin-left: 4px;
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    padding: 12px 24px;
    font-size: 13px;
  }
`;

const Toast = ({ message, duration = 2000, onClose }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      setTimeout(onClose, 300); // 等待过渡动画完成后再移除
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <ToastContainer show={show}>
      {message}
    </ToastContainer>
  );
};

export default Toast; 